import { memo } from 'react';
import { useTranslations } from 'next-intl';

import useStyles from './styles';

const PageTitle = () => {
  const t = useTranslations();
  const styles = useStyles();

  return (
    <div className={styles['page-title--block']}>
      <h3 className="title-content">{t('promotion_title')}</h3>
      <p className="sub-title-content">{t('promotion_subtitle')}</p>
    </div>
  );
};
export default memo(PageTitle);
